import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'https://dev-pilot-pay-server.pilotpay.yipgroup.local',
	isProduction: true,
	frontendIdentityUrl: 'https://identity-service-ui-dev.peakplatform.io',
	backendIdentityUrl: 'https://identity-service-api-dev.peakplatform.io',
	allowedEmailDomains: ['ascentgl.net']
};
